import React from 'react';

export const VolEventMoreInfoModal = {
  title: 'Additional Eruption And Source Information',
  body: (
    <div>
      <p>
        The additional info link will display additional eruption information. The information may include effects such as the eruption start date and end date, total numbers of injuries and houses destroyed, references and comments.
      </p>
    </div>
  ),
};
